import { gql, useLazyQuery } from '@apollo/client'

export interface ResetDecisionPageVariables {
  dealId: number
}

export interface ResetDecisionPageResponse {
  resetDecisionPage: {
    isSuccess: boolean
    errorMessage: string
    message: string
  }
}

export const RESET_DECISION_PAGE_CACHE = gql`
  query ResetDecisionPage($dealId: Int!) {
    resetDecisionPage(dealId: $dealId) {
      isSuccess
      errorMessage
      message
    }
  }
`

export const useResetDecisionPageCache = () => {
  const [resetCache, { data, loading, error }] = useLazyQuery<
    ResetDecisionPageResponse,
    ResetDecisionPageVariables
  >(RESET_DECISION_PAGE_CACHE, {
    fetchPolicy: 'network-only',
  })

  return {
    resetCache,
    data: data?.resetDecisionPage,
    loading,
    error,
  }
}
